import React from "react";
import Layout from "../Layout";
import Form from "./form";
import useApi from "Hooks/Admin/useApi";
import useAuth from "Hooks/Admin/useAuth";
import useError from "Hooks/useError";
import { message } from "constants/message";
import { withRouter } from "react-router";
import dayjs from "dayjs";
dayjs.locale("ja");

function Information(props) {
  const { params } = props.match;
  const informationId = parseInt(params.id, 10);

  const { request } = useApi();
  const auth = useAuth();
  const stateError = useError();
  const messages = message();
  const [information, setInformation] = React.useState(null);

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Admin - お知らせ編集";
  }, []);

  React.useEffect(() => {
    if (!auth.state.token) {
      return;
    }
    fetchInformation();
  }, [auth.state.token]);

  const fetchInformation = () => {
    request({
      method: "GET",
      url: `admin/information/${informationId}`,
    }).then((result) => {
      const data = {
        validFrom: result.data.data.valid_from,
        validUntil: result.data.data.valid_until,
        content: result.data.data.content,
        url: result.data.data.url,
        display: result.data.data.display,
      }

      setInformation(data);
    });
  }

  const handleSubmit = (information) => {
    request({
      method: "PUT",
      url: `admin/information/${informationId}`,
      data: {
        valid_from: information.validFrom,
        valid_until: information.validUntil,
        content: information.content,
        url: information.url,
        display: information.display,
      },
    })
      .then((data) => {
        stateError.initialize();
        props.history.push("/admin/information?success=edit");
      })
      .catch((error) => {
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: messages.validation.common,
          },
        });
      });
  };

  return (
    <Layout
      content={
        <Form
          submit={handleSubmit}
          information={information}
          isEdit={true}
        />
      }
    />
  );
}
export default withRouter(Information);
